import isEqual from 'lodash-es/isEqual'

import { updateStateValue } from '../../../../../utils/react'

export function getApplicantDraftFormValues(draft) {
  return draft?.values
}

export function getApplicantDraftSavedAt(draft) {
  return draft?.savedAt
}

export function getApplicantDraftSaveAction(nextDraftAction) {
  return currentDraft => {
    const currentValues = getApplicantDraftFormValues(currentDraft)
    const nextValues = updateStateValue(nextDraftAction, currentValues)

    if (!nextValues) {
      return nextValues
    }

    return isEqual(nextValues, currentValues)
      ? currentDraft
      : { savedAt: new Date().toISOString(), values: nextValues }
  }
}
